export const explainTypeToTextTemplatingConfigMap = {
  CONVERSATION: {
    allowDisplay: true,
    titleText: 'conversation',
    titleTextPlural: 'conversations',
    subTextPrepostion: 'from',
    mostRecentActionVerb: 'message'
  },
  VIDEO: {
    allowDisplay: true,
    titleText: 'Drift Video view',
    titleTextPlural: 'Drift Video views',
    subTextPrepostion: 'by',
    mostRecentActionVerb: 'view'
  },
  PAGE_VIEW: {
    allowDisplay: true,
    titleText: 'page visit',
    titleTextPlural: 'page visits',
    subTextPrepostion: 'from',
    mostRecentActionVerb: 'visit'
  },
  HIGH_INTENT_PAGE_VIEW: {
    allowDisplay: true,
    titleText: 'high intent page visit',
    titleTextPlural: 'high intent page visits',
    subTextPrepostion: 'from',
    mostRecentActionVerb: 'visit'
  },
  NON_HOMEPAGE_VIEW: {
    allowDisplay: true,
    titleText: 'non-homepage visit',
    titleTextPlural: 'non-homepage visits',
    subTextPrepostion: 'from',
    mostRecentActionVerb: 'visit'
  },
  HOMEPAGE_VIEW: {
    allowDisplay: true,
    titleText: 'homepage visit',
    titleTextPlural: 'homepage visits',
    subTextPrepostion: 'from',
    mostRecentActionVerb: 'visit'
  },
  EMAIL_SEND: {
    allowDisplay: false,
    titleText: '',
    titleTextPlural: '',
    subTextPrepostion: '',
    mostRecentActionVerb: ''
  },
  EMAIL_OPEN: {
    allowDisplay: true,
    titleText: 'email open',
    titleTextPlural: 'email opens',
    subTextPrepostion: 'by',
    mostRecentActionVerb: 'open'
  },
  EMAIL_CLICK: {
    allowDisplay: true,
    titleText: 'email click',
    titleTextPlural: 'email clicks',
    subTextPrepostion: 'by',
    mostRecentActionVerb: 'click'
  },
  MEETING_BOOKED: {
    allowDisplay: true,
    titleText: 'meeting booked',
    titleTextPlural: 'meetings booked',
    subTextPrepostion: 'with',
    mostRecentActionVerb: 'booked'
  },
  MEETING_CANCELED: {
    allowDisplay: false,
    titleText: '',
    titleTextPlural: '',
    subTextPrepostion: '',
    mostRecentActionVerb: ''
  },
  MEETING_RESCHEDULED: {
    allowDisplay: false,
    titleText: '',
    titleTextPlural: '',
    subTextPrepostion: '',
    mostRecentActionVerb: ''
  },
  MEETING_DELETED: {
    allowDisplay: false,
    titleText: '',
    titleTextPlural: '',
    subTextPrepostion: '',
    mostRecentActionVerb: ''
  },
  MEETING_RESCHEDULING: {
    allowDisplay: false,
    titleText: '',
    titleTextPlural: '',
    subTextPrepostion: '',
    mostRecentActionVerb: ''
  },
  MEETING_OTHER: {
    allowDisplay: false,
    titleText: '',
    titleTextPlural: '',
    subTextPrepostion: '',
    mostRecentActionVerb: ''
  },
  END_USER_IDENTIFIED: {
    allowDisplay: false,
    titleText: '',
    titleTextPlural: '',
    subTextPrepostion: '',
    mostRecentActionVerb: ''
  }
}

export const DEFAULT_TEXT_TEMPLATE = {
  allowDisplay: false,
  titleText: '',
  titleTextPlural: '',
  subTextPrepostion: '',
  mostRecentActionVerb: ''
}
